import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'groupUniversalDevices',
    standalone: false
})
export class GroupUniversalDevicesPipe implements PipeTransform {

  transform(bomModels: IBomModel[]): IBomModel[] {
    return this.groupArrayByAttributeAndIncreaseQuantity(bomModels);
  }

  groupArrayByAttributeAndIncreaseQuantity(bomModels: IBomModel[]): IBomModel[] {
    const groupedArray = bomModels?.reduce((acc, curr) => {
      const key = curr.article.ref;
      if (acc[key]) {
        acc[key].quantity += curr.quantity;
      } else {
        acc[key] = {
          ...curr,
          quantity: curr.quantity
        };
      }
      return acc;
    }, {});

    return Object.values(groupedArray || []);
  }


}
